var path = 'components/email-chips.tpl.html';
var html = " <div class=tk-email-chips layout=column> <md-chips name=emailChips placeholder={{placeholder}} secondary-placeholder={{secondaryPlaceholder}} ng-model=emails md-separator-keys=emptySeparatorKeys ng-keydown=emailChipsKeydown($event) ng-keyup=emailChipsKeyup($event)> </md-chips> <div class=tk-error-messages ng-show=!showErrors> </div> <div class=tk-error-messages ng-messages=ngModelCtrl.$error ng-show=showErrors role=alert> <div ng-message=emailFormat class=tk-error-message translate>email.invalid-format</div> <div ng-message=required class=tk-error-message translate>email.contact-list-required</div> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/email-chips.tpl.html
// module id = 1036
// module chunks = 1